export const InteractableEventTypes = {
  OnDoubleClick: "interactableondoubleclick",
  OnHover: "interactableonhover",
  OnOut: "interactableonout",
  OnInteract: "interactableoninteract",
};
